module.exports = __webpack_public_path__ + "img/sadboy.852dda6a.jpg";